module.exports = __webpack_public_path__ + "img/active2.758de5b9.png";